import React from "react";
import ReactDOM from "react-dom";
import { createStore, applyMiddleware, compose } from "redux";
import { Provider } from "react-redux";
import reduxThunk from "redux-thunk";
import global from './helpers/engine';


import App from "src/App";
import reducers from "src/reducers";

import "react-toastify/dist/ReactToastify.css";
import "src/assets/css/style.css";

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
const store = createStore(reducers, composeEnhancers(applyMiddleware(reduxThunk)));

ReactDOM.render(
  <Provider store={store}>
    <App engine={global}/>
  </Provider>,
  document.getElementById("root")
);
